onDomReady(function () {
   when($$('.js-page-navigation'), ContentDropdownGroup);
});
